(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinic-packages"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.clinic-packages').forEach((section) => {
    const filters = section.querySelectorAll('[data-package-filter]');
    const cards = section.querySelectorAll('[data-package-category]');

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const category = filter.dataset.packageFilter;
        filters.forEach((item) => {
          const active = item === filter;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        cards.forEach((card) => {
          card.hidden = category !== 'all' && card.dataset.packageCategory !== category;
        });
      });
    });
    const applyFromHash = () => { const hash = window.location.hash.slice(1).toLowerCase(); if (!/^[a-z]+$/.test(hash)) return; const button = section.querySelector('[data-package-filter="' + hash + '"]'); if (!button) return; button.click(); const bar = section.querySelector('.clinic-packages__filters'); if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    applyFromHash();
    window.addEventListener('hashchange', applyFromHash);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinic-shop-membership"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clinic-shop-hero')) {
    class ClinicShopHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.toggleButton = this.querySelector('[data-hero-toggle]');
        this.toggleIcon = this.querySelector('[data-hero-toggle-icon]');
        this.currentIndex = 0;
        this.paused = false;
        this.speed = Number(this.dataset.speed || 6) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelector('[data-hero-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
        this.toggleButton?.addEventListener('click', () => this.setPaused(!this.paused));

        if (this.dataset.autoplay === 'true' && !this.reducedMotion) this.start();
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      show(index) {
        if (!this.slides.length) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === this.currentIndex));
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (!this.paused && this.dataset.autoplay === 'true' && !this.reducedMotion) this.start();
      }

      start() {
        window.clearInterval(this.timer);
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.speed);
      }

      setPaused(paused) {
        this.paused = paused;
        this.toggleButton?.setAttribute('aria-pressed', paused ? 'true' : 'false');
        this.toggleButton?.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        if (this.toggleIcon) this.toggleIcon.textContent = paused ? '▶' : 'Ⅱ';
        if (paused) window.clearInterval(this.timer);
        else if (!this.reducedMotion) this.start();
      }
    }
    customElements.define('clinic-shop-hero', ClinicShopHero);
  }

  if (!customElements.get('clinic-shop-tabs')) {
    class ClinicShopTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            const nextIndex = (index + direction + this.tabs.length) % this.tabs.length;
            this.select(nextIndex);
            this.tabs[nextIndex].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          this.panels[tabIndex].hidden = !selected;
        });
      }
    }
    customElements.define('clinic-shop-tabs', ClinicShopTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
